"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PlayerActionTypesArray = exports.playerActionCreators = exports.spectatePlayerAction = exports.swapPiecePlayerAction = exports.dropPiecePlayerAction = exports.quitGamePlayerAction = exports.readyUpPlayerAction = exports.sellPiecePlayerAction = exports.toggleShopLockPlayerAction = exports.rerollCardsPlayerAction = exports.buyXpPlayerAction = exports.buyCardPlayerAction = void 0;
const zod_1 = require("zod");
const api_1 = require("@cc-plugins/api");
const quickChat_1 = require("./quickChat");
const buyCardSchema = zod_1.z.object({
    index: zod_1.z.number().int().nonnegative(),
});
exports.buyCardPlayerAction = (0, api_1.networkedAction)("buyCardPlayerAction", buyCardSchema);
const voidSchema = zod_1.z.undefined();
exports.buyXpPlayerAction = (0, api_1.networkedAction)("buyXpPlayerAction", voidSchema);
exports.rerollCardsPlayerAction = (0, api_1.networkedAction)("rerollCardsPlayerAction", voidSchema);
exports.toggleShopLockPlayerAction = (0, api_1.networkedAction)("toggleShopLockPlayerAction", voidSchema);
const sellPieceSchema = zod_1.z.object({ pieceId: zod_1.z.string() });
exports.sellPiecePlayerAction = (0, api_1.networkedAction)("sellPiecePlayerAction", sellPieceSchema);
exports.readyUpPlayerAction = (0, api_1.networkedAction)("readyUpPlayerAction", voidSchema);
exports.quitGamePlayerAction = (0, api_1.networkedAction)("quitGamePlayerAction", voidSchema);
const pieceLocationSchema = zod_1.z.object({
    type: zod_1.z.enum(["board", "bench"]),
    location: zod_1.z
        .number()
        .int()
        .nonnegative()
        .transform((n) => n),
});
const dropPieceSchema = zod_1.z.object({
    pieceId: zod_1.z.string(),
    to: pieceLocationSchema,
});
exports.dropPiecePlayerAction = (0, api_1.networkedAction)("dropPiecePlayerAction", dropPieceSchema);
const swapPieceSchema = zod_1.z.object({
    pieceAId: zod_1.z.string(),
    pieceBId: zod_1.z.string(),
});
exports.swapPiecePlayerAction = (0, api_1.networkedAction)("swapPiecePlayerAction", swapPieceSchema);
const spectateSchema = zod_1.z.object({
    playerId: zod_1.z.string().nullable(),
});
exports.spectatePlayerAction = (0, api_1.networkedAction)("spectatePlayerAction", spectateSchema);
exports.playerActionCreators = [
    exports.buyCardPlayerAction,
    exports.buyXpPlayerAction,
    exports.rerollCardsPlayerAction,
    exports.toggleShopLockPlayerAction,
    exports.sellPiecePlayerAction,
    exports.readyUpPlayerAction,
    exports.quitGamePlayerAction,
    exports.dropPiecePlayerAction,
    exports.swapPiecePlayerAction,
    exports.spectatePlayerAction,
    quickChat_1.quickChatPlayerAction,
];
exports.PlayerActionTypesArray = exports.playerActionCreators.map((c) => c.type);
